import React, { Component } from "react";
import axios from "axios";
import { awsUrl } from "../config";
import SmallLoader from "./smallLoader";
import "../index.css";
import * as xlsx from "xlsx";

class UploadForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      awaitingFile: false,
      parseError: false,
      parseMessage: "",
      urlSuccess: false,
      signedUrlList: [],
      downloadInProgress: false,
      selectedFilesList: [], // Added to show selected files in the UI
      docType: "saic",
    };
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  handleBeforeUnload = (e) => {
    if (this.state.awaitingFile) {
      e.preventDefault();
      e.returnValue = "Upload and extraction is in progress. Are you sure you want to refresh the page?";
      return e.returnValue;
    }
  };

  handleOcrParse = (data, fileName) => {
    let response = {
      url: "",
      error: false,
    };
    if (data.fileType === "success") {
      response.url = data.url;
    } else if (data.fileType === "error") {
      let mailParams = {
        fileName,
      };
      axios
        .post(awsUrl + "/api/sendMail", mailParams, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((data) => console.log("A mail has been sent!"))
        .catch((err) => console.log("Failed to send mail"));
      response.error = true;
    } else {
      response.error = true;
    }

    return response;
  };

  s3Poller = (fileName, originalFileName) => {
    return new Promise((resolve, reject) => {
      try {
        let encodedFileName = encodeURIComponent(`${originalFileName}.xlsx`);
        axios
          .get(awsUrl + `/api/s3Poller/${fileName}/${encodedFileName}`)
          .then((result) => {
            if (result.data.fileType) {
              let { url, error } = this.handleOcrParse(result.data, fileName);
              if (error || !url) {
                reject("error in s3 poller");
              } else {
                resolve(url);
              }
            } else {
              setTimeout(async () => {
                try {
                  let url = await this.s3Poller(fileName, originalFileName);
                  resolve(url);
                } catch (error) {
                  reject(error);
                }
              }, 3000);
            }
          })
          .catch((err) => {
            console.log("Error", err);
            reject(err);
          });
      } catch (error) {
        reject(error);
      }
    });
  };

  putToS3 = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        let fileData = file;
        let fileName = fileData.name;
        let fileNameArray = fileName.split(".");
        fileNameArray.pop();
        let originalFileName = fileNameArray.join(".");
        let fileType = fileData.type;
        let options = { headers: { "Content-Type": fileType } };

        let signedUrlData = await axios.post(awsUrl + "/api/getSignedUrl", {
          fileName,
          fileType,
        });
        let { signedUrl, key, timeStamp } = signedUrlData.data;

        await axios.put(signedUrl, fileData, options);
        axios
          .post(awsUrl + "/api/fileUploadRti", {
            key,
            fullFileName: fileName,
            timeStamp,
            docType: this.state.docType
          })
          .then(async (response) => {
            const fileName = response.data.fileName;
            const folder = fileName.split(".")[0];
            let url = await this.s3Poller(folder, originalFileName);
            resolve({ url, fileName: originalFileName });
          })
          .catch((error) => {
            console.log("error", error);
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  };

  uploadFile = async (event) => {
    event.preventDefault();
    if (!this.state.file || this.state.file.length === 0) return;

    this.setState({
      parseError: false,
      urlSuccess: false,
      signedUrlList: [],
      awaitingFile: true,
    });
    
    let { file: files } = this.state;

    // create signed URLs and upload all files to S3
    let putToS3PromiseList = [];
    for (let file of files) {
      putToS3PromiseList.push(this.putToS3(file));
    }

    let resolvedPutToS3Promises = await Promise.allSettled(putToS3PromiseList);

    let errorInAllFiles = true;
    let signedUrlList = [];
    for (let data of resolvedPutToS3Promises) {
      if (data.status === "fulfilled" && data.value) {
        errorInAllFiles = false;
        signedUrlList.push({
          url: data.value.url,
          fileName: data.value.fileName,
        });
      }
    }

    if (errorInAllFiles) {
      this.setState({
        parseError: true,
        awaitingFile: false,
        parseMessage:
          "Oops! Something went wrong. Please contact admin@insurecomp.com for further assistance.",
      });
    } else {
      this.setState({
        parseMessage: "Parsing complete!",
        parseError: false,
        urlSuccess: true,
        signedUrlList,
        awaitingFile: false,
      });
    }
  };

  handleFileUpload = (event) => {
    const files = event.target.files;
    this.setState({ 
      file: files,
      selectedFilesList: Array.from(files) 
    });
  };

  fetchExcelData = (signedUrl, fileName) => {
    return new Promise(async (resolve, reject) => {
      try {
        let resp = await axios({
          method: "get",
          url: signedUrl,
          responseType: "blob",
        });
        resolve({ data: resp.data, fileName });
      } catch (error) {
        reject(error);
      }
    });
  };

  handleDownload = async () => {
    try {
      let { signedUrlList } = this.state;
      this.setState({ downloadInProgress: true });

      let getExcelDataPromiseList = [];
      for (let data of signedUrlList) {
        getExcelDataPromiseList.push(
          this.fetchExcelData(data.url, data.fileName)
        );
      }

      let excelResponseList = await Promise.allSettled(getExcelDataPromiseList);

      // create an empty workbook to store the aggregated data
      let aggregateWorkbook = xlsx.utils.book_new();

      let allSheetsData = [];
      let columnsStyle = [];
      for (let data of excelResponseList) {
        if (data.status === "fulfilled") {
          // excel allows max 31 chars sheet name
          let sheetName = data.value.fileName;
          if (sheetName.length > 31) {
            sheetName = sheetName.substring(0, 31);
          }

          // add sheet1 data to the aggregate workbook as a new sheet
          let arrayBufferData = await data.value.data.arrayBuffer();
          let clienWorkbook = xlsx.read(arrayBufferData, {
            type: "array",
            cellStyles: true,
          });
          let clientWorksheet =
            clienWorkbook.Sheets[clienWorkbook.SheetNames[0]];
          xlsx.utils.book_append_sheet(
            aggregateWorkbook,
            clientWorksheet,
            sheetName,
            true
          );

          /* copy the styling of the client worksheet to apply 
          to the aggregate sheet */
          columnsStyle = clientWorksheet["!cols"];

          // append all the rows to a global list to prepare the aggregate sheet
          let clientWorksheetRowsList = xlsx.utils.sheet_to_json(
            clientWorksheet,
            { raw: false }
          );
          allSheetsData = [...allSheetsData, ...clientWorksheetRowsList];
        }
      }

      // attach the aggregate sheet to the final excel
      let aggregateSheet = xlsx.utils.json_to_sheet(allSheetsData);
      aggregateSheet["!cols"] = columnsStyle;
      xlsx.utils.book_append_sheet(
        aggregateWorkbook,
        aggregateSheet,
        "Aggregate",
        true
      );

      // create link to download the aggregate excel file
      let aggregateArray = xlsx.write(aggregateWorkbook, {
        bookType: "xlsx",
        type: "array",
      });
      let aggregateBlob = new Blob([aggregateArray]);
      let aggregateWorkbookLink = document.createElement("a");
      aggregateWorkbookLink.href = window.URL.createObjectURL(aggregateBlob);
      aggregateWorkbookLink.download = "Aggregate.xlsx";
      aggregateWorkbookLink.id = "aggregate";
      document.body.appendChild(aggregateWorkbookLink);
      aggregateWorkbookLink.click();
      document.body.removeChild(aggregateWorkbookLink);

      this.setState({ downloadInProgress: false });
    } catch (error) {
      this.setState({ downloadInProgress: false });
      console.log(error);
    }
  };

  resetFormState = () => {
    this.setState({
      awaitingFile: false,
      parseError: false,
      parseMessage: "",
      urlSuccess: false,
      signedUrlList: [],
      selectedFilesList: [],
      file: null
    });
  };

  render() {
    const {
      awaitingFile,
      urlSuccess,
      parseError,
      parseMessage,
      downloadInProgress,
      selectedFilesList,
      docType,
    } = this.state;

    return (
      <div className="container pb-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="card shadow-sm border-0 rounded-lg p-4 p-md-5 bg-white">
              
              <div className="text-center mb-4">
                <h2 className="h4 font-weight-bold text-dark">Select quote document(s) for extraction.</h2>
              </div>

              <form onSubmit={this.uploadFile}>
                {/* Document Type Dropdown */}
                <div className="form-group mb-4">
                  <label htmlFor="doc-type-select" className="font-weight-bold text-dark mb-2">
                    Document Type
                  </label>
                  <select
                    id="doc-type-select"
                    className="custom-select-premium"
                    value={docType}
                    onChange={(e) => this.setState({ docType: e.target.value })}
                    disabled={awaitingFile}
                  >
                    <option value="pnic">PNIC</option>
                    <option value="saic">SAIC</option>
                  </select>
                </div>

                {/* Modernized File Input Wrapper */}
                <div className="form-group mb-4">
                  <div className={`custom-file-dropzone text-center position-relative ${awaitingFile ? "disabled" : ""}`}>
                    <input
                      id="file-upload-input"
                      className="custom-file-input"
                      type="file"
                      multiple
                      onClick={this.resetFormState}
                      onChange={this.handleFileUpload}
                      required
                      disabled={awaitingFile}
                    />
                    <label htmlFor="file-upload-input" className={`d-block py-4 px-3 mb-0 ${awaitingFile ? "" : "cursor-pointer"}`}>
                      <div className="mb-2">
                        <svg className="bi bi-cloud-arrow-up text-primary" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"/>
                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.517l-.518.058C2.12 6.813 1 7.947 1 9.318 1 10.743 2.19 12 3.781 12h8.906C13.98 12 15 11.025 15 9.773c0-1.217-1.02-2.115-2.288-2.115h-.565l-.016-.563C12.108 4.975 10.234 3 8 3c-1.921 0-3.411 1.41-3.921 2.872a.5.5 0 0 1-.952-.319z"/>
                        </svg>
                      </div>
                      <span className="font-weight-bold d-block text-dark">
                        Choose files or drag them here
                      </span>
                      <span className="text-muted small">
                        Accepts raw document formats
                      </span>
                    </label>
                  </div>
                </div>

                {/* Show Selected Files List */}
                {selectedFilesList.length > 0 && (
                  <div className="mb-4">
                    <h6 className="text-muted small text-uppercase font-weight-bold mb-2">Selected Files ({selectedFilesList.length})</h6>
                    <ul className="list-group list-group-flush border rounded">
                      {selectedFilesList.map((file, idx) => (
                        <li key={idx} className="list-group-item d-flex justify-content-between align-items-center py-2 px-3 bg-light small">
                          <span className="text-truncate mr-3">{file.name}</span>
                          <span className="badge badge-secondary badge-pill">
                            {(file.size / 1024).toFixed(1)} KB
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-primary btn-block py-2 font-weight-bold shadow-sm" 
                  disabled={selectedFilesList.length === 0 || awaitingFile}
                >
                  {awaitingFile ? "Processing..." : "Submit"}
                </button>
              </form>

              {/* Status and Action Banners */}
              <div className="mt-4">
                {awaitingFile && (
                  <div className="alert alert-info border-0 shadow-sm d-flex align-items-center justify-content-center" role="alert">
                    <span>Extracting documents, please hold...</span>
                    <SmallLoader />
                  </div>
                )}

                {urlSuccess && (
                  <div className="alert alert-success border-0 shadow-sm text-center p-4" role="alert">
                    <h5 className="alert-heading font-weight-bold mb-2">Extraction Complete!</h5>
                    <p className="small text-muted mb-3">Your compiled report is ready for download.</p>
                    <button
                      className="btn btn-success font-weight-bold px-4 shadow-sm"
                      onClick={this.handleDownload}
                      disabled={downloadInProgress}
                    >
                      {downloadInProgress ? (
                        <span>Downloading <SmallLoader /></span>
                      ) : (
                        "Download Aggregated File (.xlsx)"
                      )}
                    </button>
                  </div>
                )}

                {parseError && (
                  <div className="alert alert-danger border-0 shadow-sm" role="alert">
                    <div className="d-flex align-items-start">
                      <span className="mr-2">⚠️</span>
                      <div>
                        <h6 className="font-weight-bold mb-1">Execution Error</h6>
                        <p className="small mb-0 text-dark">{parseMessage}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadForm;
